<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-download', fontSet: 'fad'}"
	[headerText]="T.RECORDING_FILESET_CONVERSION_DIALOG_TITLE | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		@if (afterViewInit) {
			<mat-tab-group
				[(selectedIndex)]="selectedMatTabIndex"
				[dynamicHeight]="true"
				[mat-stretch-tabs]="false"
				class="fullHeight fileSetContainer"
				color="accent"
				style="overflow: auto; flex: 1"
			>
				<mat-tab label="{{ T.RECORDING_FILESET_CONVERSION_DIALOG_TAB_CREATE | translate }}">
					<ng-template matTabContent>
						<mat-form-field class="nameInput" color="accent">
							<mat-label>{{ T.RECORDING_FILESET_CONVERSION_DIALOG_NAME | translate }}</mat-label>
							<input [(ngModel)]="nameForSet" matInput name="name" type="text" />
						</mat-form-field>
						<p>
							<mat-icon color="warn" fontIcon="fa-exclamation-triangle" fontSet="fad" inline />
							{{ T.RECORDING_FILESET_CONVERSION_DIALOG_HINT | translate }}
						</p>
						<div class="h-100" style="contain: strict">
							<p>
								{{ T.RECORDING_FILESET_CONVERSION_DIALOG_ROOMSELECT | translate }}
							</p>
							<sim-training-room-navigation-panel
								(onTrainingRoomClicked)="selectTrainingRoom($event)"
								[autoSelectIfSingular]="true"
								[allowSelectionWhenOccupied]="true"
								[collapseAllCards]="true"
								[enableDraggingRooms]="false"
								[expandAllCards]="false"
								[roomCapability]="RoomCapability.TrainTheTrainer"
								[singleRoom]="true"
								[trainingRoomWhitelist]="null"
							/>
						</div>
					</ng-template>
				</mat-tab>
				<mat-tab label="{{ T.RECORDING_FILESET_CONVERSION_DIALOG_TAB_EXISTING_SETS | translate }}">
					<ng-template matTabContent>
						<sim-scenario-archive-filesets-panel [scenarioRecordingId]="data.scenarioRecordingId" />
					</ng-template>
				</mat-tab>
			</mat-tab-group>
		}
	</ng-container>

	<ng-container actions>
		@if (selectedMatTabIndex === index_CreationTab) {
			<sim-button
				(onClick)="confirm()"
				[disabled]="!selectedTrainingRoom || !nameForSet"
				[hasPermission]="Permissions.ScenarioRecording_ConvertToFileSet"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
				[label]="T.RECORDING_FILESET_CONVERSION_DIALOG_START_CONVERSION"
				class="creationButton"
				color="accent"
			/>
		}
		<sim-button (onClick)="close()" [icon]="{fontSet: 'fad', fontIcon: 'fa-times'}" [label]="T.BUTTON_CLOSE" color="warn" />
	</ng-container>
</sim-basic-material-dialog>
